import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/studiovinari': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M480.3 187.7L484.5 215.7V243.7L459.4 287.8 419.6 366.2 363.5 433.7 284.4 471.5 266.7 496 259 508 249.4 512S266.7 448.4 268.8 448.4C270.9 448.4 289.1 449.1 289.1 449.1L355.8 410.5 263.3 436.6 207.4 473.4 184.6 501.4 178 502.8 198.8 429.2 205.7 423.7 226.4 436.6 314.7 391.4 371.5 339.9 386.3 271.5 260.9 294.8 276.1 276.6 102.7 223.3 184.6 212.8 18.6 89.9 133.5 108 32.2 0 285.1 126.6 253.6 88.6 378 163 234.7 64 253.4 102.4 203.8 84.3 158.3 0 352.9 122 310 66.2 418 162.6 430 153.7 409 137.3 413.2 99.5 451 89.1 480.2 113.8 491.7 118 484.7 124.2 493.2 136.2 480.1 143.6 469.8 163.8 480.3 187.7z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/studiovinari.js
// module id = hua/
// module chunks = 144